<div class="page">
    <div class="page-padding">
        <div class="page-header-custom">
            <h1 class="page-title">{{'caronasolidaria' | translate}} | <span>{{'lerqrcode' | translate}}</span></h1>
        </div>

        <!-- Modos -->
        <div class="d-flex" style="gap: 12px; margin: 16px 0;">
            <a (click)="setMode('entry')" class="btn"
               [ngClass]="mode === 'entry' ? 'btn-primary' : 'btn-secondary'">{{'registrarentrada' | translate}}</a>
            <a (click)="setMode('exit')" class="btn"
               [ngClass]="mode === 'exit' ? 'btn-primary' : 'btn-secondary'">{{'registrarsaida' | translate}}</a>
        </div>

        <div class="row">
            <!-- Coluna scanner / leitura -->
            <div class="col-md-5">
                <div class="card p-3 mb-3">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                        <strong>{{'leituraqr' | translate}}</strong>
                        <a (click)="toggleScanner()" class="btn btn-sm"
                           [ngClass]="scannerEnabled ? 'btn-danger' : 'btn-secondary'">
                            {{ (scannerEnabled ? 'desligarcamera' : 'ligarcamera') | translate }}
                        </a>
                    </div>

                    <zxing-scanner *ngIf="scannerEnabled"
                                   [enable]="scannerEnabled"
                                   [formats]="allowedFormats"
                                   [device]="currentDevice"
                                   (scanSuccess)="onScanSuccess($event)"
                                   (camerasFound)="onCamerasFound($event)"
                                   style="width:100%;display:block;border:1px solid #ccc">
                    </zxing-scanner>
                </div>

                <!-- Conferência: dados CRUS lidos do QR (informativo; o form abaixo é a fonte gravada) -->
                <div class="card p-3 mb-3" *ngIf="qrLido">
                    <strong class="mb-2">{{'dadoslidosdoqr' | translate}}</strong>
                    <p class="mb-1"><strong>RE:</strong> {{ qrLido.re ? qrLido.re : '-' }}</p>
                    <p class="mb-1"><strong>{{'bloc' | translate}}:</strong> {{ qrLido.bloco ? qrLido.bloco : '-' }}</p>
                    <p class="mb-1"><strong>{{'placa' | translate}}:</strong> {{ qrLido.placa ? qrLido.placa : '-' }}</p>
                    <p class="mb-0 text-danger small" *ngIf="blocNaoEncontrado">
                        {{'bloc' | translate}} '{{ blocNaoEncontrado }}' {{'blocnaoencontrado' | translate}}
                    </p>
                </div>
            </div>

            <!-- Coluna formulário / ação -->
            <div class="col-md-7">
                <!-- Form completo do colaborador: só no modo ENTRADA -->
                <div class="card p-3 mb-3" *ngIf="mode === 'entry'">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="input-material">
                                <input class="form-control" type="text" [(ngModel)]="form.employeeName" maxlength="255"/>
                                <label>{{'nome' | translate}}</label>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="input-material">
                                <input class="form-control" type="text" [(ngModel)]="form.re" maxlength="255"/>
                                <label>*RE</label>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="input-material">
                                <input class="form-control text-uppercase" type="text" [(ngModel)]="form.licensePlate" maxlength="7"/>
                                <label>*{{'placa' | translate}}</label>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="input-material">
                                <input class="form-control" type="text" [(ngModel)]="form.cpf"
                                       [mask]="this.translate.currentLang==='pt'? '000.000.000-00' : ''"/>
                                <label>{{'cpf' | translate}}</label>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- MODO ENTRADA: cards de bloco -->
                <div *ngIf="mode === 'entry'">
                    <h5>{{'escolhabloco' | translate}}</h5>
                    <div class="row">
                        <div class="col-6 col-md-4 mb-3" *ngFor="let b of blocs">
                            <div class="card p-3 text-center"
                                 [ngClass]="{ 'border-primary': selectedBlocId === b.bloc.id }"
                                 style="cursor: pointer;"
                                 (click)="setSelectedBloc(b)">
                                <strong>{{ b.bloc.name }}</strong>
                                <span [ngClass]="b.available <= 0 ? 'text-danger' : 'text-success'">
                                    {{ b.available }} {{'livres' | translate}} / {{ b.capacity }}
                                </span>
                            </div>
                        </div>
                        <div class="col-12" *ngIf="blocs.length === 0">
                            <p class="text-muted">{{'nenhumblococapacidade' | translate}}</p>
                        </div>
                    </div>

                    <!-- Vaga (texto livre) do bloco selecionado -->
                    <div *ngIf="selectedBlocId" class="input-material mb-2">
                        <input id="vaga" class="form-control" type="text" [(ngModel)]="vaga" maxlength="50"/>
                        <label for="vaga"><span>{{'vaga' | translate}}</span></label>
                    </div>

                    <a (click)="submitEntry()" class="btn btn-primary mt-2">{{'registrarentrada' | translate}}</a>
                </div>

                <!-- MODO SAÍDA: busca por VAGA (fallback RE/placa) + lista de abertos -->
                <div *ngIf="mode === 'exit'">
                    <div class="card p-3 mb-3">
                        <div class="input-material">
                            <input class="form-control" type="text" [(ngModel)]="form.re" maxlength="255"/>
                            <label>*{{'vagareouplaca' | translate}}</label>
                        </div>
                        <a (click)="submitExit()" class="btn btn-primary">{{'buscarregistro' | translate}}</a>
                    </div>

                    <div *ngIf="openRecords.length > 1" class="alert alert-warning py-2">
                        {{'maisdeumregistro' | translate}}
                    </div>

                    <div *ngFor="let r of openRecords" class="card p-3 mt-3">
                        <h6>{{'registroemaberto' | translate}}</h6>
                        <p class="mb-1"><strong>{{'nome' | translate}}:</strong> {{ r.employeeName ? r.employeeName : '-' }}</p>
                        <p class="mb-1"><strong>RE:</strong> {{ r.re }}</p>
                        <p class="mb-1"><strong>{{'bloc' | translate}}:</strong> {{ r.bloc?.name }}</p>
                        <p class="mb-1"><strong>{{'vaga' | translate}}:</strong> {{ r.vaga ? r.vaga : '-' }}</p>
                        <p class="mb-1"><strong>{{'entrada' | translate}}:</strong> {{ r.entryAt | date:'dd/MM/yyyy HH:mm' }}</p>
                        <a (click)="confirmExit(r)" class="btn btn-primary mt-2">{{'registrarsaida' | translate}}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- MODAL SAÍDA MANUAL (correção §46.6 passo 2): há registro aberto ao tentar nova entrada -->
<div class="modal fade" id="manualExitModal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content p-0">
            <div class="modal-header">
                <h5 class="modal-title text-primary">{{'saidamanual' | translate}}</h5>
                <button type="button" class="pt-0" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">X</span></button>
            </div>
            <div class="modal-body">
                <p class="text-muted">{{'correcaomanual' | translate}}</p>
                <div *ngIf="pendingOpenRecord" class="card p-2 mb-3" style="background-color:#F5F3EC">
                    <p class="mb-1"><strong>{{'nome' | translate}}:</strong> {{ pendingOpenRecord.employeeName ? pendingOpenRecord.employeeName : '-' }}</p>
                    <p class="mb-1"><strong>{{'bloc' | translate}}:</strong> {{ pendingOpenRecord.bloc?.name }}</p>
                    <p class="mb-1"><strong>{{'entrada' | translate}}:</strong> {{ pendingOpenRecord.entryAt | date:'dd/MM/yyyy HH:mm' }}</p>
                </div>
                <div class="row">
                    <div class="col-12 mb-3">
                        <label class="d-block mb-1">{{'datahorasaida' | translate}}</label>
                        <input class="form-control w-100" type="datetime-local" [(ngModel)]="manualExit.exitAt"/>
                    </div>
                    <div class="col-12 mb-3">
                        <label class="d-block mb-1">*{{'justificativa' | translate}}</label>
                        <textarea class="form-control w-100" rows="2" [(ngModel)]="manualExit.exitNote"></textarea>
                    </div>
                    <div class="col-12">
                        <a (click)="submitManualExit()" class="btn btn-primary w-100">{{'registrarsaidamanual' | translate}}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- MODAL ENTRADA MANUAL (correção §46.6 passo 4): saída sem registro em aberto -->
<div class="modal fade" id="manualEntryModal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content p-0">
            <div class="modal-header">
                <h5 class="modal-title text-primary">{{'entradamanual' | translate}}</h5>
                <button type="button" class="pt-0" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">X</span></button>
            </div>
            <div class="modal-body">
                <p class="text-muted">{{'correcaomanual' | translate}}</p>
                <div class="row">
                    <div class="col-md-6 mb-3">
                        <label class="d-block mb-1">{{'nome' | translate}}</label>
                        <input class="form-control w-100" type="text" [(ngModel)]="manualEntry.employeeName" maxlength="255"/>
                    </div>
                    <div class="col-md-6 mb-3">
                        <label class="d-block mb-1">*RE</label>
                        <input class="form-control w-100" type="text" [(ngModel)]="manualEntry.re" maxlength="255"/>
                    </div>
                    <div class="col-md-6 mb-3">
                        <label class="d-block mb-1">{{'placa' | translate}}</label>
                        <input class="form-control w-100 text-uppercase" type="text" [(ngModel)]="manualEntry.licensePlate" maxlength="7"/>
                    </div>
                    <div class="col-md-6 mb-3">
                        <label class="d-block mb-1">*{{'bloc' | translate}}</label>
                        <select class="form-control w-100" [(ngModel)]="manualEntry.blocId">
                            <option [ngValue]="null">{{'selecione' | translate}}</option>
                            <option *ngFor="let b of blocs" [ngValue]="b.bloc.id">
                                {{ b.bloc.name }} ({{ b.available }}/{{ b.capacity }})
                            </option>
                        </select>
                    </div>
                    <div class="col-md-6 mb-3">
                        <label class="d-block mb-1">{{'vaga' | translate}}</label>
                        <input class="form-control w-100" type="text" [(ngModel)]="manualEntry.vaga" maxlength="50"/>
                    </div>
                    <div class="col-12 mb-3">
                        <label class="d-block mb-1">{{'datahoraentrada' | translate}}</label>
                        <input class="form-control w-100" type="datetime-local" [(ngModel)]="manualEntry.entryAt"/>
                    </div>
                    <div class="col-12 mb-3">
                        <label class="d-block mb-1">*{{'justificativa' | translate}}</label>
                        <textarea class="form-control w-100" rows="2" [(ngModel)]="manualEntry.entryNote"></textarea>
                    </div>
                    <div class="col-12">
                        <a (click)="submitManualEntry()" class="btn btn-primary w-100">{{'registrarentradamanual' | translate}}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
